import { Component } from '@angular/core';

@Component({
  selector: 'app-revoke-permissions',
  standalone: true,
  imports: [],
  templateUrl: './revoke-permissions.component.html',
  styleUrl: './revoke-permissions.component.scss'
})
export class RevokePermissionsComponent {

}
